import SummaryItem from 'components/SummaryItem/SummaryItem'
import { numberToText } from 'utils/utils'

// TODO needs translation
function TilesToAddForFreeShipping({ tilesToAddForFreeShipping }) {
  if (tilesToAddForFreeShipping) {
    return (
      <SummaryItem
        highlighted
        text={`Add ${numberToText(tilesToAddForFreeShipping)} more tile${
          tilesToAddForFreeShipping > 1 ? 's' : ''
        } for free shipping!`}
      />
    )
  }
  return null
}

export default TilesToAddForFreeShipping
